import React from 'react';
import { Minus } from 'react-feather';

import BarIcon from 'assets/img/icons/bar.svg';
import Star from 'assets/img/icons/star.svg';
import UpdateProgress from 'assets/img/icons/edit-text-bar.svg';

function Index(props) {
  switch (props.icon) {
    case '3dots':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="25"
          height="6"
          viewBox="0 0 18 6"
          fill="none"
          style={{ cursor: 'pointer' }}
        >
          <circle
            cx="2.07692"
            cy="3.00023"
            r="2.07692"
            transform="rotate(-90 2.07692 3.00023)"
            fill="#5F5F5F"
          />
          <circle
            cx="9.00002"
            cy="4.00023"
            r="2.07692"
            transform="rotate(-90 9.00002 3.00023)"
            fill="#5F5F5F"
          />
          <circle
            cx="15.9231"
            cy="5.00023"
            r="2.07692"
            transform="rotate(-90 15.9231 3.00023)"
            fill="#5F5F5F"
          />
        </svg>
      );
      break;

    default:
      break;
  }
  return (
    <div
      className={`btn__custom ${props?.className}`}
      style={{
        ...props?.style,
        cursor: props?.disabled ? 'not-allowed' : 'pointer',
        pointerEvents: props?.disabled ? 'none' : 'auto',
        // backgroundColor: props?.disabled ? "#C1C1C1" : ""
      }}
      onClick={() => {
        if (props?.func) {
          props?.func();
        }
      }}
    >
      {props?.icon === 'detail' && (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="12"
        height="9"
        viewBox="0 0 10 7"
        fill="none"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4.88097 2.59582C5.39222 2.59582 5.80669 2.97799 5.80669 3.44945C5.80669 3.92092 5.39222 4.30309 4.88097 4.30309C4.36968 4.30309 3.95524 3.92092 3.95524 3.44945C3.95524 2.97799 4.36968 2.59582 4.88097 2.59582ZM6.73242 3.44945C6.73242 2.50653 5.90348 1.74219 4.88097 1.74219C3.85841 1.74219 3.0295 2.50654 3.0295 3.44945C3.0295 4.39237 3.85841 5.15672 4.88097 5.15672C5.90348 5.15672 6.73242 4.39238 6.73242 3.44945Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.73801 3.32179C9.08934 1.41737 7.16015 0.0351562 4.87963 0.0351562C2.59915 0.0351562 0.669952 1.41738 0.0212708 3.32179C-0.00708961 3.40505 -0.00708961 3.49433 0.0212708 3.57759C0.669952 5.482 2.59915 6.86423 4.87963 6.86423C7.16015 6.86423 9.08935 5.482 9.73801 3.57759C9.76637 3.49433 9.76637 3.40505 9.73801 3.32179ZM8.80854 3.44969C8.23656 4.94208 6.69285 6.01059 4.87963 6.01059C3.06645 6.01059 1.52273 4.94208 0.950741 3.44969C1.52273 1.9573 3.06645 0.88879 4.87963 0.88879C6.69285 0.88879 8.23656 1.95729 8.80854 3.44969Z"
          fill="white"
        />
      </svg>
      )}
      {props?.icon === 'download' && (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
      >
        <path
          d="M6.75 0H9.25C9.66562 0 10 0.334375 10 0.75V6H12.7406C13.2969 6 13.575 6.67188 13.1812 7.06563L8.42813 11.8219C8.19375 12.0562 7.80937 12.0562 7.575 11.8219L2.81562 7.06563C2.42188 6.67188 2.7 6 3.25625 6H6V0.75C6 0.334375 6.33437 0 6.75 0ZM16 11.75V15.25C16 15.6656 15.6656 16 15.25 16H0.75C0.334375 16 0 15.6656 0 15.25V11.75C0 11.3344 0.334375 11 0.75 11H5.33437L6.86562 12.5312C7.49375 13.1594 8.50625 13.1594 9.13437 12.5312L10.6656 11H15.25C15.6656 11 16 11.3344 16 11.75ZM12.125 14.5C12.125 14.1562 11.8438 13.875 11.5 13.875C11.1562 13.875 10.875 14.1562 10.875 14.5C10.875 14.8438 11.1562 15.125 11.5 15.125C11.8438 15.125 12.125 14.8438 12.125 14.5ZM14.125 14.5C14.125 14.1562 13.8438 13.875 13.5 13.875C13.1562 13.875 12.875 14.1562 12.875 14.5C12.875 14.8438 13.1562 15.125 13.5 15.125C13.8438 15.125 14.125 14.8438 14.125 14.5Z"
          fill="white"
        />
      </svg>
      )}
      {props?.icon === 'export' && (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="11"
        height="12"
        viewBox="0 0 11 12"
        fill="none"
      >
        <g opacity="0.4">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5.42456 0C5.54959 -1.43868e-07 5.6695 0.0496681 5.75791 0.138078L7.36705 1.74722C7.55116 1.93133 7.55116 2.22982 7.36705 2.41392C7.18295 2.59803 6.88446 2.59803 6.70035 2.41392L5.42456 1.13813L4.14877 2.41392C3.96467 2.59803 3.66618 2.59803 3.48207 2.41392C3.29797 2.22982 3.29797 1.93133 3.48207 1.74722L5.09121 0.138079C5.17962 0.0496686 5.29953 1.43869e-07 5.42456 0Z"
            fill="#5F5F5F"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5.42504 0.0439453C5.6854 0.0439453 5.89647 0.255011 5.89647 0.515374V6.90796C5.89647 7.16833 5.6854 7.37939 5.42504 7.37939C5.16468 7.37939 4.95361 7.16833 4.95361 6.90796V0.515374C4.95361 0.255011 5.16468 0.0439453 5.42504 0.0439453Z"
            fill="#5F5F5F"
          />
        </g>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0.471429 5.06641C0.731791 5.06641 0.942857 5.27747 0.942857 5.53783C0.942857 6.82051 1.37728 7.95694 2.14894 8.7693C2.91706 9.57791 4.04702 10.095 5.5 10.095C6.95299 10.095 8.08294 9.57791 8.85106 8.7693C9.62272 7.95694 10.0571 6.82051 10.0571 5.53783C10.0571 5.27747 10.2682 5.06641 10.5286 5.06641C10.7889 5.06641 11 5.27747 11 5.53783C11 7.03345 10.4916 8.4113 9.53466 9.41866C8.5742 10.4298 7.18987 11.0378 5.5 11.0378C3.81013 11.0378 2.4258 10.4298 1.46534 9.41866C0.508436 8.4113 0 7.03345 0 5.53783C0 5.27747 0.211066 5.06641 0.471429 5.06641Z"
          fill="#5F5F5F"
        />
      </svg>
      )}
      {props?.icon === 'create' && (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        width="10"
        height="10"
        viewBox="0 0 24 24"
        fill="white"
      >
        <path
          fillRule="evenodd"
          d="M 11 2 L 11 11 L 2 11 L 2 13 L 11 13 L 11 22 L 13 22 L 13 13 L 22 13 L 22 11 L 13 11 L 13 2 Z"
        />
      </svg>
      )}
      {props?.icon === 'delete' && (
      <Minus size={14} />
      )}
      {props?.icon === '3bar' && (
      <img src={BarIcon} alt="3bar" />
      )}
      {props?.icon === 'star' && (
      <img src={Star} alt="star icon" />
      )}
      {props?.icon === 'update_progress' && (
      <img src={UpdateProgress} alt="update icon" />
      )}
      {props?.children}
    </div>
  );
}

export default Index;
